import { useMemo } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { deskQueryFromSearch, type DeskTab } from '../../../lib/deskPeriod'
import { filtersFromSearch } from '../../../lib/deskFilters'

/** The desk's URL state: title from the path, period/compare/filters from the query string. */
export function useDeskState(tab: DeskTab) {
  const { pub = '' } = useParams()
  const [sp, setSp] = useSearchParams()
  const spKey = sp.toString()
  const q = useMemo(() => deskQueryFromSearch(new URLSearchParams(spKey), tab), [spKey, tab])
  const filters = useMemo(() => filtersFromSearch(new URLSearchParams(spKey)), [spKey])
  return { pub, sp, spKey, setSp, q, filters, search: spKey }
}
